import React, { useEffect, useRef } from 'react';
import JsBarcode from 'jsbarcode';

// Renderiza o código de barras do boleto em Interleaved 2 of 5 (INT25),
// mesmo padrão do RCPGR001 (MSBAR3("INT25")), a partir das 44 posições de
// `codigo_de_barras`. Não faz nenhuma validação de negócio — quem decide se
// o boleto é elegível é `boletoEligibility.js`.
function BoletoBarcode({ codigoBarras }) {
  const svgRef = useRef(null);

  useEffect(() => {
    if (!svgRef.current || !codigoBarras) return;
    try {
      const svg = svgRef.current;
      JsBarcode(svg, codigoBarras, {
        format: 'ITF',
        displayValue: false,
        height: 50,
        margin: 0,
      });
      // O jsbarcode define width/height fixos em pixels — ex.: "810px" —
      // (largura proporcional à quantidade de dígitos), o que vaza pra fora
      // de containers estreitos (ex.: o modal). Convertendo pra viewBox (só
      // números, sem unidade — "px" tornaria o viewBox inválido), o CSS
      // (width: 100%; height: auto) consegue escalar o desenho pra caber,
      // sem cortar nem esticar.
      const width = parseFloat(svg.getAttribute('width'));
      const height = parseFloat(svg.getAttribute('height'));
      if (width && height) {
        svg.setAttribute('viewBox', `0 0 ${width} ${height}`);
        svg.removeAttribute('width');
        svg.removeAttribute('height');
      }
    } catch {
      // Código de barras fora do padrão (ex.: tamanho ímpar) — não quebra a
      // tela, só não desenha o barcode.
    }
  }, [codigoBarras]);

  if (!codigoBarras) return null;

  return <svg ref={svgRef} className="boleto-print-barcode" />;
}

export default BoletoBarcode;
